import { createStore } from '../../lib/create-store';

import { getActions, getInitialState, getReducer } from '.';

const ACTION_PREFIX = 'TEXT_TO_SPEECH';

const initialState = getInitialState();
const reducer = getReducer(ACTION_PREFIX);

export const textToSpeechStore = createStore({
  name: 'textToSpeechStore',
  initialState,
  reducer,
});

export const textToSpeechActions = getActions(ACTION_PREFIX);
